import { observer } from "mobx-react-lite";
import * as React from "react";
import { useMemo } from "react";
import { classNames } from "src/common/classNames";
import { PropsTableCell } from "src/components/ReactiveTable/components/ReactiveTable/componentProps";
import { AbstractRow } from "src/components/ReactiveTable/RtTypes";

import * as styles from "./TableCell.module.less";

/**
 * Компонент ячейки таблицы
 */
export const TableCell = observer(
  <TRow extends AbstractRow>(props: PropsTableCell<TRow>) => {
    const { row, column, style, className } = props;

    // Мемоизируем содержимое ячейки для избежания пересчетов на каждый рендер
    const content = useMemo(() => {
      if (column.render) {
        return column.render(row);
      }
      const value = (row as Record<string, unknown>)[column.key];
      return value != null ? String(value) : "";
    }, [row, column.render, column.key]);

    return (
      <div
        className={classNames([
          styles.tableCell,
          column.cellClassName,
          className,
        ])}
        style={style}
        data-column-key={column.key}
      >
        {content}
      </div>
    );
  },
);
